function l(a, e) {
  var E = e.attribute;
  return a = a.replace(r, "&amp;").replace(t, "&gt;").replace(p, "&lt;"), E && (a = a.replace(_, "&apos;").replace(c, "&quot;")), a;
}
var r = /&/g, t = />/g, p = /</g, _ = /'/g, c = /"/g;
export {
  l as default
};
//# sourceMappingURL=index.es262.js.map
